import LayoutTabs from './LayoutTabs';

export default LayoutTabs;
